import { render } from "./TabListe.vue?vue&type=template&id=0650ec1f&scoped=true"
import script from "./TabListe.vue?vue&type=script&lang=js"
export * from "./TabListe.vue?vue&type=script&lang=js"

import "./TabListe.vue?vue&type=style&index=0&id=0650ec1f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0650ec1f"]])

export default __exports__